import _ from 'lodash'

const settingsError = (state) => _.get(state, 'errors')
const isLoading = (state) => _.get(state, 'loading')
const settings = (state) => _.get(state, 'settings')
const login = (state) => _.get(state, 'login')
const chaptersList = (state) => _.get(state, 'chapters')
const appCore = (state) => _.get(state, 'app_core')
const baseCore = (state) => _.get(state, 'core')
const ci_cd = (state) => _.get(state, 'ci_cd')
const styles = (state) => _.get(state, 'styles')
const user = (state) => _.get(state, 'user')
const web = (state) => _.get(state, 'web')
const event = (state) => _.get(state, 'event')
const backUser = (state) => _.get(state, 'back_user')
const url = (state) => _.get(state, 'url')

export default {
	settingsError,
	isLoading,
	settings,
	login,
	ci_cd,
	styles,
	chaptersList,
	appCore,
	baseCore,
	web,
	user,
	backUser,
	event,
	url
}
